import { bool, number, object, ref, string } from 'yup';
import { get } from 'lodash';
import { FormikValues } from 'formik';
import moment from 'moment';

import { ShareType } from 'api';

const SharingSchema = (initialValues?: FormikValues) => {
  return object()
    .shape({
      content_id: string().required(),
      share_type: string().required(),
      share_at: number().when('share_type', {
        is: shareType => shareType === ShareType.Scheduled,
        then: number().test('is-future', 'REQUIRED MESSAGE', (value: number) => {
          return moment.unix(value).isAfter();
        }),
        otherwise: number().nullable(true),
      }),
      facebook: object().shape({
        active: bool(),
        limit: number().nullable(true),
        user_commentary: string().when('active', {
          is: true,
          then: string().max(ref('limit')),
          otherwise: string(),
        }),
        share_session_id: string().nullable(),
      }),
      twitter: object().shape({
        active: bool(),
        limit: number().nullable(true),
        network_id: string().nullable(true),
        user_commentary: string().when('active', {
          is: true,
          then: string().max(ref('limit')),
          otherwise: string(),
        }),
        share_session_id: string().nullable(),
      }),
      linkedin: object().shape({
        active: bool(),
        limit: number().nullable(true),
        network_id: string().nullable(true),
        user_commentary: string().when('active', {
          is: true,
          then: string().max(ref('limit')),
          otherwise: string(),
        }),
        share_session_id: string().nullable(),
      }),
    })
    .test('has-active-network', 'REQUIRED MESSAGE', (values: FormikValues) => {
      const activeValues = initialValues || values;
      return (
        get(activeValues, 'twitter.active') ||
        get(activeValues, 'linkedin.active') ||
        get(activeValues, 'facebook.active')
      );
    });
};

export { SharingSchema };
